import React from 'react';
import brandLogoUrl from '../assets/verve-brand-logo.svg';
import './ProtectedBrandLogo.css';

const blockMediaAction = (event) => {
  event.preventDefault();
};

const ProtectedBrandLogo = ({ className = 'login-novo-logo-image', alt = 'Verve' }) => (
  <div className="protected-brand-logo">
    <img
      src={brandLogoUrl}
      alt={alt}
      className={className}
      decoding="async"
      fetchPriority="high"
      draggable={false}
      onContextMenu={blockMediaAction}
      onDragStart={blockMediaAction}
    />
    <span
      className="protected-brand-logo-shield"
      aria-hidden="true"
      onContextMenu={blockMediaAction}
      onDragStart={blockMediaAction}
    />
  </div>
);

export default ProtectedBrandLogo;
